import { render, staticRenderFns } from "./ActionGroups.vue?vue&type=template&id=fbb736ec&scoped=true&"
import script from "./ActionGroups.vue?vue&type=script&lang=js&"
export * from "./ActionGroups.vue?vue&type=script&lang=js&"
import style0 from "./ActionGroups.vue?vue&type=style&index=0&id=fbb736ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb736ec",
  null
  
)

export default component.exports